import styled from "styled-components";

export const StyledVerificationQueueTab = styled.div`
  padding: 16px;

  .table-container {
    background: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }
`;